import TimelineControl from '@components/map/timeline_control/TimelineControl'
import _http_v1 from '@packs/http_requests/_http_v1'
import store from '../../store/store'
import colors from '../../helpers/colors'
import geoJSONHelper from '../../helpers/geoJSON'

export default function TimelineController(opts={}){
    BaseConstructor.call(this)
    let {container} = opts
    let elements = {}
    let context = this

    let states
    let timelineControl
    let circlesFeature

    this.generate = () =>{
        

        if(store.timelineConfigStore.getOption('active')){
            if(!circlesFeature){
                circlesFeature = new L.featureGroup()
                map.addLayer(circlesFeature)
            }
            
            L.circle([-23.600795,  -45.97279], {
                radius: 228.01471026807525*1000,
                color:'var(--gray-dark)',
                opacity: 0.5,
                fill:false,
                dashArray: '5, 10',
                weight: 2
            }).addTo(circlesFeature);
            L.circle([-23.600795,  -45.97279], {
                radius: 228.01471026807525*1000/4*3,
                color:'var(--gray-dark)',
                opacity: 0.5,
                fill:false,
                dashArray: '5, 10',
                weight: 2
            }).addTo(circlesFeature);
            L.circle([-23.600795,  -45.97279], {
                radius: 228.01471026807525*1000/4*2,
                color:'var(--gray-dark)',
                opacity: 0.5,
                fill:false,
                dashArray: '5, 10',
                weight: 2
            }).addTo(circlesFeature);
            L.circle([-23.600795,  -45.97279], {
                radius: 228.01471026807525*1000/4,
                color:'var(--gray-dark)',
                opacity: 0.5,
                fill:false,
                dashArray: '5, 10',
                weight: 2
            }).addTo(circlesFeature);

            


            getRadarData().then(images=>{
                
                if(images && images.json.length > 0){
                    let states = buildRadarStates(images.json)
                    let city_json
                    
                    timelineControl = new TimelineControl({
                        map:map, 
                        states:states,play:false,
                        options:{contentType:'imageOverlay', imageBounds:{}, speed: 2}
                    })
                    
                    timelineControl.generate()

                    _http_v1.request('/images/get_images_ref', 'GET', {model: 'Radar', model_id: 1, names: (states.map(x=>x.key))}).then(data=>{
                        states.map(x=>  {x.analyze = data.filter(y=>y.name === x.key)[0]})
                    })

                    geoJSONHelper.getLimits('city_limit', {simplified:true}).then(data=>{
                        city_json = data
                    })

                    let boolean = false

                    // evento de troca de imagem da timeline
                    timelineControl.on('CHANGE_STATE', state=>{

                        // if(state && state.analyze && !boolean){

                        //     state.analyze.options.analyze.forEach((data,index)=>{
                        //         let options = {
                        //             borderColor: 'red',
                        //             iconShape: 'circle-dot'
                        //         };
                                
                                
                        //         L.marker([data[0], data[1]], {icon: L.BeautifyIcon.icon(options)}).addTo(map)
                        //     })
                        //     boolean = true
                        // }
                    })
                    // timelineControl.play()
                }
            })
        } else {
            if(timelineControl){
                timelineControl.destroy()
                timelineControl= null
            }
            if(circlesFeature){
                circlesFeature.clearLayers()
            }
        }
    }

    this.update = () =>{

    }

    const buildRadarStates = images_list =>{

        const imagesOrder = images =>{
            return images.sort((a,b)=> toDate(a.key.replace('daee/cappi_24h/', '').replace('.png', '')).getTime() - toDate(b.key.replace('daee/cappi_24h/', '').replace('.png', '')).getTime())
        }

        const toDate  = text =>{
            return new Date(`${text.substring(0,4)}-${text.substring(4,6)}-${text.substring(6,8)} ${text.substring(8,10)}:${text.substring(10,12)}`)
        }

        if(images_list.length > 1){
            images_list = imagesOrder(images_list) //ordenando
        }
        
        //criando states
        return images_list.map(image=>{
            return {
                key: image.key,
                title: normalizeTitle(image.key),
                content: image.url
            }
        })
    }

    const getRadarData = async _ =>{
        return _http_v1.request('radars/1/last_images', 'GET', {limit: 20, with_link:true, path_suffix: 'cappi_24h'})
    }

    const normalizeTitle = title =>{
        title = title.replace('daee/cappi_24h/', '').replace('.png', '')
        return `<span>${moment(title, "YYYYMMDDHHmm").subtract(3, 'hours').format("DD-MM-YYYY HH:mm")}</span>`
    }

    init()

    function init(){
        store.timelineConfigStore.subscribe('SET_OPTION', data=>{
            if(data.option === 'active'){
                context.generate()
            }
        })

        store.mainConfigStore.subscribe('MEASUREMENTS_LOAD', _ =>{
            let show_radar = store.timelineConfigStore.getOption('active')
            if(show_radar && timelineControl){
                getRadarData().then(images=>{
                    if(images && images.json.length > 0){
                        let states = buildRadarStates(images.json) 
                        timelineControl.update(states)
                    }
                })
            }
            
        })
    }
}

TimelineController.prototype = Object.create(BaseConstructor.prototype)